import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { AuthProvider } from "@/contexts/AuthContext";
import { Landing } from "@/pages/Landing";
import { Roadmap } from "@/pages/Roadmap";
import { Radio } from "@/pages/Radio";
import { Dashboard } from "@/pages/Dashboard";
import { ServerPanel } from "@/pages/ServerPanel";
import { Premium } from "@/pages/Premium";
import { PremiumHub } from "@/pages/PremiumHub";
import { PremiumCheckout } from "@/pages/PremiumCheckout";
import { PremiumSuccess } from "@/pages/PremiumSuccess";
import { PremiumCancel } from "@/pages/PremiumCancel";
import { LegacyCheckoutRedirect } from "@/pages/LegacyCheckoutRedirect";
import { Admin } from "@/pages/Admin";
import { HostAccessGuide } from "@/pages/HostAccessGuide";
import { Terms } from "@/pages/Terms";
import { Privacy } from "@/pages/Privacy";
import { ProtectedRoute } from "@/components/ProtectedRoute";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route
              path="/host-access"
              element={
                <ProtectedRoute ownerOnly>
                  <HostAccessGuide />
                </ProtectedRoute>
              }
            />
            <Route path="/roadmap" element={<Roadmap />} />
            <Route path="/radio" element={<Radio />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/server/:guildId"
              element={
                <ProtectedRoute>
                  <ServerPanel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/premium"
              element={<Premium />}
            />
            <Route
              path="/premium/checkout"
              element={
                <ProtectedRoute>
                  <LegacyCheckoutRedirect />
                </ProtectedRoute>
              }
            />
            <Route
              path="/premium/:guildId/checkout"
              element={
                <ProtectedRoute>
                  <PremiumCheckout />
                </ProtectedRoute>
              }
            />
            <Route
              path="/premium/success"
              element={
                <ProtectedRoute>
                  <PremiumSuccess />
                </ProtectedRoute>
              }
            />
            <Route
              path="/premium/cancel"
              element={
                <ProtectedRoute>
                  <PremiumCancel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/premium/:guildId"
              element={
                <ProtectedRoute>
                  <Premium />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute ownerOnly>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Landing />} />
          </Routes>
        </Layout>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
